import { combineReducers } from 'redux'
import { REDUCER_NAME } from './const'
import { reducer as manageReducer, REDUCER_NAME as MANAGE_REDUCER_NAME } from './manage'


const reducer = combineReducers({
    [MANAGE_REDUCER_NAME]: manageReducer,
})

export {
    reducer,
    REDUCER_NAME,
}



// WEBPACK FOOTER //
// ./src/modules/email/state/index.js